import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase';

function EditTeamInfo({teamId}) {
    
    const [team, setTeam] = useState();
    const [teamApiId, setTeamApiId] = useState(0);
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    useEffect(() => {

        const teamRef = firestore.collection("teams").doc(teamId);
        teamRef.onSnapshot(doc => {
            const team = {id: doc.id, ...doc.data()}
            setTeam(team);
            setTeamApiId(team.api_id)
        });

    }, [teamId])

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const teamRef = firestore.collection("teams").doc(teamId);
            const data = {
                api_id: teamApiId
            }
            teamRef.update(data);
        } catch (error) {
            
        }
    }

    return (
        <form onSubmit={submitHandler}>
            <label>Football API ID team ID</label>
            <input className="form-control mb-2" value={teamApiId} onChange={e => setTeamApiId(e.target.value)} placeholder="Team ID" />
            <button className="btn btn-primary btn-block">Lagre</button>
        </form>
    )
}
export default EditTeamInfo